<ng-container *ngIf="desktop | async">
<div class="modal-content">
  <div class="top">
    <qrcode [margin]="0" [qrdata]="link" [width]="expanded ? 188 : 101" [errorCorrectionLevel]="'M'"></qrcode>

    <ng-container *ngIf="!expanded" >
      <ng-container i18n class="cta">Download the App</ng-container>
    </ng-container>

    <ng-container *ngIf="expanded" >
      <ng-container i18n class="cta-expanded">Scan with your phone to download</ng-container>
    </ng-container>
  </div>

  <ng-container *ngIf="expanded">
    <div class="bottom">
      <a class="btn btn-frame" href="https://apps.apple.com/us/app/hostel-hop/id6473739477" target="_blank">
        <div class="btn-store">
          <div class="icon">
            <svg-icon [svgStyle]="{'width.px': 21, 'height.px': 24}" src="/assets/icons/apple.svg"></svg-icon>
          </div>
          <div class="msg">
            <span class="prompt">
              Download on the
            </span>
            <span class="name">
              App Store
            </span>
          </div>
        </div>
      </a>
      <a class="btn btn-frame" href="https://play.google.com/store/apps/details?id=com.hostel_hop_inc.hostel_hop_mobile" target="_blank">
        <div class="btn-store">
          <div class="icon">
            <svg-icon [svgStyle]="{'width.px': 21, 'height.px': 22}" src="/assets/icons/play.svg"></svg-icon>
          </div>
          <div class="msg">
            <span class="prompt">
              Get it on
            </span>
            <span class="name">
              Google Play
            </span>
          </div>
        </div>
      </a>
    </div>
  </ng-container>
</div>
</ng-container>

<ng-container *ngIf="!(desktop | async)">
  <ng-container *ngIf="isMobile && isAndroid" >
    <div class="download-widget" (click)="redirectToPlayStore()">
      <img src="assets/images/h_logo.png" alt="Download the app logo" class="app-logo">
      <div class="download-text">
        <ng-container i18n>Download the app</ng-container>
      </div>
    </div>
  </ng-container>
  
  <ng-container *ngIf="isMobile && isIOS" >
    <div class="download-widget" (click)="redirectToAppStore()">
      <img src="assets/images/h_logo.png" alt="Download the app logo" class="app-logo">
      <ng-container i18n class="download-text">Download the app</ng-container>
    </div>
  </ng-container>
</ng-container>
